import i18next from 'i18next';

const state = {
  topics: [],
  speakers: {},
  featuredSpeakers: {},
  categories: [],
  homeContent: {},
  daf: {},
  loader: false,
  topicCategories: [],
  captcha_sitekey: process.env.MIX_CAPTCHA_SITEKEY
};

const getters = {
  categories(state) {
    return state.categories;
  },
  topics(state) {
    return state.topics;
  },
  speakers(state) {
    return state.speakers;
  },
  daf(state) {
    return state.daf;
  }
};

const actions = {
  loadSpeakers({ commit }) {
    return axios
      .get('/api/magidei-shiur')
      .then(function (response) {
        commit('SAVE_SPEAKERS', response.data);
      })
      .catch(function (error) {
        throw new Error(`API ${error}`);
      });
  },
  loadFeaturedSpeakers({ commit }) {
    return axios
      .get('/api/magidei-shiur/torah/featured')
      .then(function (response) {
        commit('SAVE_FEATURED_SPEAKERS', response.data);
      })
      .catch(function (error) {
        throw new Error(`API ${error}`);
      });
  },
  loadTopics({ commit }) {
    return axios
      .get('/api/topics')
      .then(function (response) {
        commit('SAVE_TOPICS', response.data);
      })
      .catch(function (error) {
        throw new Error(`API ${error}`);
      });
  },
  loadCategories({ commit }) {
    return axios
      .get('/api/categories')
      .then(function (response) {
        commit('SAVE_CATEGORIES', response.data);
      })
      .catch(function (error) {
        throw new Error(`API ${error}`);
      });
  },
  loadHomeContent({ commit }) {
    return axios
      .get('/api/home-sidebar')
      .then(response => {
        commit('SAVE_HOME_CONTENT', response.data);
      })
      .catch(function (error) {
        throw new Error(`API ${error}`);
      });
  },
  loadTodayDAF: function (context) {
    return axios
      .get('/api/shiur/today')
      .then(response => {
        this.dispatch('auth/loadUser', response.data.user);
        this.dispatch('profile/loadSavedShiurim', response.data.savedShiurim);
        this.dispatch('profile/loadFollowingSpeakers', response.data.followingSpeakers);
        this.dispatch('profile/loadShiurimNewsletter', response.data.shiurimNewsletter);
        context.commit('SAVE_DAF', response.data.shiurim.length ? response.data.shiurim[0] : null);
      })
      .catch(function (error) {
        throw new Error(`API ${error}`);
      });
  },
  toggleLoader: function (context, status) {
    context.commit('TOGGLE_LOADER', status);
  },
  loadTopicCategories({ state, commit }) {
    return new Promise(resolve => {
      if (state.topicCategories.length > 0) resolve(state.topicCategories);
      axios.get('/api/topic-categories').then(resp => {
        commit('SAVE_TOPIC_CATEGORIES', resp.data);
        resolve(resp.data);
      });
    });
  },
};

const mutations = {
  SAVE_SPEAKERS(state, speakers) {
    state.speakers = speakers
  },
  SAVE_FEATURED_SPEAKERS(state, speakers) {
    state.featuredSpeakers = speakers
  },
  SAVE_TOPICS(state, topics) {
    state.topics.splice(0);
    topics.forEach(s => state.topics.push(s))
  },
  SAVE_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  SAVE_HOME_CONTENT(state, homeContent) {
    state.homeContent = homeContent;
  },
  SAVE_DAF(state, daf) {
    state.daf = daf;
  },
  TOGGLE_LOADER(state, status) {
    state.loader = status;
  },
  SAVE_TOPIC_CATEGORIES(state, categories) {
    categories.push({ name: i18next.t('KW:allTopics'), url_key: 'all', image: { url: '/static/img/talmud_page.jpeg' } });
    state.topicCategories = categories;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
